/* LIBRARIES  */
import React, { Fragment } from 'react'
//import PropTypes from 'prop-types';

/* HOCs */
import { DI } from 'modules'
//import page from 'hoc/page';

/* COMMON COMPONENTS */
import Component from 'components/component'
import Checkbox from 'components/form/checkbox'

/* LOCAL COMPONENTS */

/* HELPERS */

export class Restrictions extends Component {
  // STATIC PROPERTIES
  static propTypes = {}

  static defaultProps = {}

  // GETTERS & SETTERS

  // LIFECYCLE (constructor, etc)

  // METHODS

  // RENDER METHODS
  render() {
    const {
      restrictions,
      downloadableEnabled,
      isRestrictionsAgreed,
      onChange,
      user,
      common,
    } = this.props
    const { strings } = common
    return (
      <Fragment>
        <div className="live-restrictions">
          <div className="live-restrictions__title">
            {strings['page.video.view.restrictions']}
          </div>
          <div className="live-restrictions__text">
            {restrictions.split(/\n/g).map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>
        </div>
        {user.isSignedIn && downloadableEnabled && (
          <div className="live-agree">
            <Checkbox checked={isRestrictionsAgreed} onChange={onChange}>
              {strings['page.lives.view.book.restrictions']}
            </Checkbox>
          </div>
        )}
      </Fragment>
    )
  }
}

export default DI([])(Restrictions)
